import React from 'react';
import PropTypes from 'prop-types';
import { FDAlert } from '@facet-wealth/design';
import { getFormattedDateWithTimezone } from 'Helpers/DateTime';

const AlertPicker = ({ resource }) => {
  if (resource.attr('type') === 'sent') {
    return (
      <FDAlert
        title={resource.attr('title') + getFormattedDateWithTimezone(new Date(resource.attr('time')))}
        description={resource.attr('message')}
        status={resource.attr('status')}
      />
    );
  }

  return (
    <FDAlert
      title={resource.attr('title')}
      description={resource.attr('message')}
      status={resource.attr('status')}
    />
  );
};

AlertPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default AlertPicker;
